import React from "react";

import { motion } from "framer-motion";

import CustomerGrowthChart from "../charts/CustomerGrowthChart";
import DonutChart from "../charts/DonutChart";
import RevenueChart from "../charts/RevenueChart";
import ChartCard from "../shared/ChartCard";

const CHARTS = [
  {
    key: "revenue-trend",
    title: "Revenue Trend",
    render: (data, showComparison) => (
      <RevenueChart
        categories={data.revenue.categories}
        currentData={data.revenue.chartData}
        previousData={data.revenue.previousPeriodChartData}
        showComparison={showComparison}
      />
    ),
  },
  {
    key: "ticket-status",
    title: "Ticket Status",
    render: (data) => (
      <DonutChart
        centerLabel="Total"
        centerValue={data.tickets.total}
        labels={Object.keys(data.tickets.byStatus)}
        series={Object.values(data.tickets.byStatus)}
      />
    ),
  },
  {
    key: "customer-growth",
    title: "Customer Growth",
    render: (data) => (
      <CustomerGrowthChart
        categories={data.customers.growth.categories}
        churned={data.customers.growth.churned}
        newCustomers={data.customers.growth.newCustomers}
      />
    ),
  },
  {
    key: "invoice-status",
    title: "Invoice Status",
    render: (data) => (
      <DonutChart
        centerLabel="Total"
        labels={Object.keys(data.invoices.statusDistribution)}
        series={Object.values(data.invoices.statusDistribution)}
      />
    ),
  },
];

const OverviewTab = ({ data, loading, showComparison }) => (
  <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
    {CHARTS.map((chart, index) => (
      <motion.div
        animate={{ opacity: 1, y: 0 }}
        initial={{ opacity: 0, y: 12 }}
        key={chart.key}
        transition={{ delay: index * 0.1, duration: 0.3, ease: "easeOut" }}
      >
        <ChartCard loading={loading} title={chart.title}>
          {data && chart.render(data, showComparison)}
        </ChartCard>
      </motion.div>
    ))}
  </div>
);

export default OverviewTab;
